import React from "react";


const nature = ["درسی سرگرمیوں میں شمولیت", "ہوم ورک کی باقاعدگی","نظم و ضبط کی پابندی", "کھیلوں میں شمولیت", "بزم ادب میں شمولیت"," اساتذہ اور ساتھیوں سے میل جول اور بات چیت"];
export default function ReportData2(props) {
  
  let arr = []
  for (let i = 0; i < 6; i++) {
    arr.push(DataFormat(i, props))
  }
  arr.push(DataFormat(11, props))
  return arr;
 }

 

const DataFormat = (d,props) => {
  return {
    Nature: nature[d],
    VG:parseInt(props.data[d+20])===1?  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill="currentColor"
    className="bi bi-check"
    viewBox="0 0 16 16"
  >
    <path d="M10.97 4.97a.75.75 0 0 1 1.07 1.05l-3.99 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.267.267 0 0 1 .02-.022z" />{" "}
  </svg>:"",
    G: (1-parseInt(props.data[d+20]))===1?  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill="currentColor"
    className="bi bi-check"
    viewBox="0 0 16 16"
  >
    
    <path d="M10.97 4.97a.75.75 0 0 1 1.07 1.05l-3.99 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.267.267 0 0 1 .02-.022z" />{" "}
  </svg>:"",
    ReMarks:props.data[28+d],
  }
}


